import ExpandableLink from './ExpandableLink';

export default ExpandableLink;
